import {
  Box,
  Center,
  Checkbox,
  CheckboxGroup,
  Flex,
  FormControl,
  FormLabel,
  Grid,
  GridItem,
  HStack,
  Input,
  Radio,
  RadioGroup,
  Text,
  Textarea,
  VStack,
} from '@chakra-ui/react'
import moment from 'moment'
import React, { useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { CardContent } from '../../../../../../Components/Card/card'
import { totalNonWebEnabledPage } from '../..'
const _ = require('underscore')

function PatientDemographics({ formView }) {
  const {
    // handleSubmit,
    // reset,
    // register,
    // errors,
    control,
    setValue,
    // clearErrors,
  } = useForm()

  useEffect(() => {
    if (formView) {
      const data = formView
      _.keys(data).map(e => {
        return setValue(e, data[e])
      })
    }
  }, [formView, setValue])

  return (
    <CardContent>
      <Box>
        <Flex
          bg="#B7DDE9"
          fontSize="14px"
          w="100%"
          pl="10px"
          mb="10px"
          fontWeight="bold"
        >
          Patient Demographics
        </Flex>
        <Box>
          <Controller
            name="namePatient"
            control={control}
            defaultValue={formView.namePatient}
            render={props => (
              <FormControl>
                <FormLabel>Name</FormLabel>
                <Input
                  _readOnly={{
                    border: '1px solid #ccc',
                  }}
                  variant="no-effects"
                  bg="#F9F9F9"
                  border="1px solid black"
                  isReadOnly
                  value={props.value}
                  onChange={props.onChange}
                  onBlur={props.onBlur}
                />
              </FormControl>
            )}
          />
        </Box>
        <Box pt="10px">
          <Controller
            name="addressPatient"
            control={control}
            defaultValue={formView.addressPatient}
            render={props => (
              <FormControl>
                <FormLabel>Address</FormLabel>
                <Textarea
                  _readOnly={{
                    border: '1px solid #ccc',
                  }}
                  variant="no-effects"
                  bg="#F9F9F9"
                  border="1px solid black"
                  isReadOnly
                  value={props.value}
                  onChange={props.onChange}
                  onBlur={props.onBlur}
                />
              </FormControl>
            )}
          />
        </Box>
        <Flex
          pt="10px"
          pb="10px"
          direction={{ base: 'column', sm: 'column', md: 'row', lg: 'row' }}
        >
          <Box w="100%" pr={{ base: '0px', sm: '0px', md: '10px', lg: '10px' }}>
            <Controller
              name="homePhone"
              control={control}
              defaultValue={formView.homePhone}
              render={props => (
                <FormControl>
                  <FormLabel>Home Phone</FormLabel>
                  <Input
                    type="number"
                    _readOnly={{
                      border: '1px solid #ccc',
                    }}
                    variant="no-effects"
                    bg="#F9F9F9"
                    border="1px solid black"
                    isReadOnly
                    value={props.value}
                    onChange={props.onChange}
                    onBlur={props.onBlur}
                  />
                </FormControl>
              )}
            />
          </Box>
          <Box
            w="100%"
            pt={{ base: '10px', md: '0px' }}
            pl={{ base: '0px', sm: '0px', md: '10px', lg: '10px' }}
          >
            <Controller
              name="cellPhone"
              control={control}
              defaultValue={formView.cellPhone}
              render={props => (
                <FormControl>
                  <FormLabel>Cell Phone</FormLabel>
                  <Input
                    type="number"
                    _readOnly={{
                      border: '1px solid #ccc',
                    }}
                    variant="no-effects"
                    bg="#F9F9F9"
                    border="1px solid black"
                    isReadOnly
                    value={props.value}
                    onChange={props.onChange}
                    onBlur={props.onBlur}
                  />
                </FormControl>
              )}
            />
          </Box>
        </Flex>
        <Flex
          pt="10px"
          pb="10px"
          direction={{ base: 'column', sm: 'column', md: 'row', lg: 'row' }}
        >
          <Box w="100%" pr={{ base: '0px', sm: '0px', md: '10px', lg: '10px' }}>
            <Controller
              name="SSN"
              control={control}
              defaultValue={formView.SSN}
              render={props => (
                <FormControl>
                  <FormLabel>SSN#</FormLabel>
                  <Input
                    type="number"
                    _readOnly={{
                      border: '1px solid #ccc',
                    }}
                    variant="no-effects"
                    bg="#F9F9F9"
                    border="1px solid black"
                    isReadOnly
                    value={props.value}
                    onChange={props.onChange}
                    onBlur={props.onBlur}
                  />
                </FormControl>
              )}
            />
          </Box>
          <Box
            w="100%"
            pt={{ base: '10px', md: '0px' }}
            pl={{ base: '0px', sm: '0px', md: '10px', lg: '10px' }}
          >
            <Controller
              name="DOB"
              control={control}
              defaultValue={moment(new Date(formView.DOB)).format('MM/DD/YYYY')}
              render={props => (
                <FormControl>
                  <FormLabel>DOB (mm/dd/yy)</FormLabel>
                  <Input
                    _readOnly={{
                      border: '1px solid #ccc',
                    }}
                    variant="no-effects"
                    bg="#F9F9F9"
                    border="1px solid black"
                    isReadOnly
                    value={props.value}
                    onChange={props.onChange}
                    onBlur={props.onBlur}
                  />
                </FormControl>
              )}
            />
          </Box>
        </Flex>
        <Controller
          name="primary"
          control={control}
          defaultValue={formView.primary}
          render={props => (
            <FormControl>
              <FormLabel>Primary Care Physician</FormLabel>
              <Input
                _readOnly={{
                  border: '1px solid #ccc',
                }}
                variant="no-effects"
                bg="#F9F9F9"
                border="1px solid black"
                isReadOnly
                value={props.value}
                onChange={props.onChange}
                onBlur={props.onBlur}
              />
            </FormControl>
          )}
        />
        <Flex
          bg="#B7DDE9"
          fontSize="14px"
          w="100%"
          mt="20px"
          mb="10px"
          pl="10px"
          fontWeight="bold"
        >
          Emergency Contact
        </Flex>
        <Box>
          <Controller
            name="nameEmergency"
            control={control}
            defaultValue={formView.nameEmergency}
            render={props => (
              <FormControl>
                <FormLabel>Name</FormLabel>
                <Input
                  _readOnly={{
                    border: '1px solid #ccc',
                  }}
                  variant="no-effects"
                  bg="#F9F9F9"
                  border="1px solid black"
                  isReadOnly
                  value={props.value}
                  onChange={props.onChange}
                  onBlur={props.onBlur}
                />
              </FormControl>
            )}
          />
        </Box>
        <Flex
          pt="10px"
          pb="10px"
          direction={{ base: 'column', sm: 'column', md: 'row', lg: 'row' }}
        >
          <Box w="100%" pr={{ base: '0px', sm: '0px', md: '10px', lg: '10px' }}>
            <Controller
              name="relationship"
              control={control}
              defaultValue={formView.relationship}
              render={props => (
                <FormControl>
                  <FormLabel>Relationship</FormLabel>
                  <Input
                    _readOnly={{
                      border: '1px solid #ccc',
                    }}
                    variant="no-effects"
                    bg="#F9F9F9"
                    border="1px solid black"
                    isReadOnly
                    value={props.value}
                    onChange={props.onChange}
                    onBlur={props.onBlur}
                  />
                </FormControl>
              )}
            />
          </Box>
          <Box
            w="100%"
            pt={{ base: '10px', md: '0px' }}
            pl={{ base: '0px', sm: '0px', md: '10px', lg: '10px' }}
          >
            <Controller
              name="phone"
              control={control}
              defaultValue={formView.phone}
              render={props => (
                <FormControl>
                  <FormLabel>Phone</FormLabel>
                  <Input
                    type="number"
                    _readOnly={{
                      border: '1px solid #ccc',
                    }}
                    variant="no-effects"
                    bg="#F9F9F9"
                    border="1px solid black"
                    isReadOnly
                    value={props.value}
                    onChange={props.onChange}
                    onBlur={props.onBlur}
                  />
                </FormControl>
              )}
            />
          </Box>
        </Flex>
        <VStack
          mt="15px"
          alignItems="flex-start"
          display={{ base: 'flex', lg: 'none' }}
          pb="0.5rem"
        >
          <Text fontWeight="bold">
            Grant Permission to access medical information
          </Text>
          <Box>
            <Controller
              name="grantPermissionYesNo"
              control={control}
              defaultValue={formView.grantPermissionYesNo || ''}
              render={props => (
                <FormControl>
                  <RadioGroup
                    isDisabled
                    defaultValue={props.value}
                    onChange={props.onChange}
                    value={props.value}
                    onBlur={props.onBlur}
                  >
                    <HStack direction="row">
                      <Radio value="yes">Yes</Radio>
                      <Radio value="no">No</Radio>
                    </HStack>
                  </RadioGroup>
                </FormControl>
              )}
            />
          </Box>
        </VStack>
        <HStack
          mt="15px"
          alignItems="flex-start"
          display={{ base: 'none', lg: 'flex' }}
          pb="0.5rem"
        >
          <Text fontWeight="bold" w="max-content">
            Grant Permission to access medical information
          </Text>
          <Box>
            <Controller
              name="grantPermissionYesNo"
              control={control}
              defaultValue={formView.grantPermissionYesNo || ''}
              render={props => (
                <FormControl>
                  <RadioGroup
                    isDisabled
                    defaultValue={props.value}
                    onChange={props.onChange}
                    value={props.value}
                    onBlur={props.onBlur}
                  >
                    <HStack direction="row">
                      <Radio value="yes">Yes</Radio>
                      <Radio value="no">No</Radio>
                    </HStack>
                  </RadioGroup>
                </FormControl>
              )}
            />
          </Box>
        </HStack>
        <Flex
          bg="#B7DDE9"
          fontSize="14px"
          w="100%"
          pl="10px"
          mt="10px"
          mb="10px"
          fontWeight="bold"
        >
          <Text fontWeight="bold">Race and Ethnicity Survey</Text>
        </Flex>
        <Flex
          textAlign="start"
          fontSize="14px"
          mb="10px"
          justifyContent="flex-start"
        >
          <Text>
            Please place a check indicating one choice under race and one choice
            under ethnicity. You are under no obligation to answer any of the
            questions below.
          </Text>
        </Flex>
        <Flex pb="5px">
          <Text>Race</Text>
        </Flex>
        <Flex>
          <Controller
            name="race"
            control={control}
            defaultValue={formView.race}
            render={props => (
              <FormControl>
                <RadioGroup
                  isDisabled
                  onChange={props.onChange}
                  value={props.value}
                  onBlur={props.onBlur}
                  w="100%"
                >
                  <Grid
                    w="100%"
                    templateColumns={{
                      base: 'repeat(1,1fr)',
                      sm: 'repeat(1,1fr)',
                      md: 'repeat(1,1fr)',
                      lg: 'repeat(2, 1fr)',
                    }}
                    gap={{ base: 2, lg: 4 }}
                  >
                    <GridItem w="100%">
                      <VStack alignItems="flex-start">
                        <Radio value="american">
                          American Indian or Alaska Native
                        </Radio>
                        <Radio value="african">Black or African American</Radio>
                        <Radio value="white">White</Radio>
                        <Radio value="unknown">Unknown</Radio>
                      </VStack>
                    </GridItem>
                    <GridItem w="100%">
                      <VStack alignItems="flex-start">
                        <Radio value="asian">Asian</Radio>
                        <Radio value="native">
                          Native Hawaiian or Pacific Islander
                        </Radio>
                        <Radio value="decline">Decline</Radio>
                        <HStack>
                          <Radio value="otherRace" />
                          <Controller
                            name="raceOther"
                            control={control}
                            defaultValue=""
                            render={props => (
                              <FormControl>
                                <Input
                                  _readOnly={{
                                    border: '1px solid #ccc',
                                  }}
                                  variant="no-effects"
                                  readOnly
                                  bg="#F9F9F9"
                                  border="1px solid black"
                                  w={{
                                    base: '100%',
                                    sm: '100%',
                                    md: 'max-content',
                                  }}
                                  placeholder="Other"
                                  value={props.value}
                                  onChange={props.onChange}
                                  onBlur={props.onBlur}
                                />
                              </FormControl>
                            )}
                          />
                        </HStack>
                      </VStack>
                    </GridItem>
                  </Grid>
                </RadioGroup>
              </FormControl>
            )}
          />
        </Flex>
        <Flex pt="20px" pb="5px">
          <Text>Ethnicity</Text>
        </Flex>
        <Controller
          name="ethnicity"
          control={control}
          defaultValue={formView.ethnicity}
          render={props => (
            <FormControl>
              <RadioGroup
                onChange={props.onChange}
                value={props.value}
                onBlur={props.onBlur}
                w="100%"
                isDisabled
              >
                <Grid
                  w="100%"
                  templateColumns={{
                    base: 'repeat(1,1fr)',
                    sm: 'repeat(1,1fr)',
                    md: 'repeat(1,1fr)',
                    lg: 'repeat(2, 1fr)',
                  }}
                  gap={1}
                >
                  <GridItem w="100%">
                    <VStack alignItems="flex-start">
                      <Radio value="ethniHispanic">
                        Hispanic or Latino Ethnicity
                      </Radio>
                      <Radio value="ethniDecline">Decline</Radio>
                    </VStack>
                  </GridItem>
                  <GridItem w="100%">
                    <VStack alignItems="flex-start">
                      <Radio value="ethniNon">
                        Non Hispanic or Latino Ethnicity
                      </Radio>
                      <Radio value="ethniUnknown">Unknown</Radio>
                    </VStack>
                  </GridItem>
                </Grid>
              </RadioGroup>
            </FormControl>
          )}
        />

        <Flex pt="20px" pb="5px">
          <Text>Language</Text>
        </Flex>
        <Controller
          name="language"
          control={control}
          render={props => (
            <FormControl>
              <CheckboxGroup
                onChange={e => {
                  setValue('language', e)
                  // clearErrors("language")
                }}
                value={props.value}
                onBlur={props.onBlur}
                w="100%"
                isDisabled
              >
                <Grid
                  w="100%"
                  templateColumns={{
                    base: 'repeat(1,1fr)',
                    sm: 'repeat(1,1fr)',
                    md: 'repeat(1,1fr)',
                    lg: 'repeat(2, 1fr)',
                  }}
                  gap={2}
                >
                  <Checkbox value="english">English</Checkbox>
                  <Checkbox value="spanish">Spanish</Checkbox>
                  <Checkbox value="russian">Russian</Checkbox>

                  <Checkbox value="indianPage6">
                    Indian (includes Hindi & Tamil)
                  </Checkbox>
                  <HStack>
                    <Checkbox value="otherLanguage"></Checkbox>
                    <Controller
                      name="other"
                      control={control}
                      defaultValue=""
                      render={props => (
                        <FormControl>
                          <Input
                            _readOnly={{
                              border: '1px solid #ccc',
                            }}
                            variant="no-effects"
                            readOnly
                            bg="#F9F9F9"
                            border="1px solid black"
                            w={{
                              base: '100%',
                              sm: '100%',
                              md: 'max-content',
                            }}
                            placeholder="Other"
                            value={props.value}
                            onChange={props.onChange}
                            onBlur={props.onBlur}
                          />
                        </FormControl>
                      )}
                    />
                  </HStack>
                </Grid>
              </CheckboxGroup>
            </FormControl>
          )}
        />
        <Flex
          bg="#B7DDE9"
          fontSize="14px"
          w="100%"
          mt="20px"
          mb="10px"
          pl="10px"
          fontWeight="bold"
        >
          Advance Directive
        </Flex>
        <Controller
          name="advance"
          control={control}
          defaultValue=""
          render={props => (
            <FormControl>
              <RadioGroup
                onChange={props.onChange}
                value={props.value}
                onBlur={props.onBlur}
                w="100%"
                isDisabled
              >
                <Grid
                  w="100%"
                  templateColumns={{
                    base: 'repeat(1,1fr)',
                    sm: 'repeat(1,1fr)',
                    md: 'repeat(1,1fr)',
                    lg: 'repeat(2, 1fr)',
                  }}
                  gap={2}
                >
                  <GridItem w="100%">
                    <VStack alignItems="flex-start">
                      <Radio value="advance">Advance Directive</Radio>
                      <Radio value="adNone">None on File</Radio>
                    </VStack>
                  </GridItem>
                  <GridItem w="100%">
                    <VStack alignItems="flex-start">
                      <Radio value="adNot">{`Do Not Resuscitate Order (DNR)`}</Radio>
                    </VStack>
                  </GridItem>
                </Grid>
              </RadioGroup>
            </FormControl>
          )}
        />
        <Flex
          bg="#B7DDE9"
          fontSize="14px"
          w="100%"
          mt="20px"
          mb="10px"
          pl="10px"
          fontWeight="bold"
        >
          Grant Permission to leave Message
        </Flex>
        <Controller
          name="grant"
          control={control}
          render={props => (
            <FormControl>
              <CheckboxGroup
                onChange={e => {
                  setValue('grant', e)
                  // clearErrors("grant")
                }}
                value={props.value}
                onBlur={props.onBlur}
                w="100%"
              >
                <Grid
                  w="100%"
                  templateColumns={{
                    base: 'repeat(1,1fr)',
                    sm: 'repeat(1,1fr)',
                    md: 'repeat(1,1fr)',
                    lg: 'repeat(1, 1fr)',
                    xl: 'repeat(2, 1fr)',
                  }}
                >
                  <Checkbox
                    alignItems="baseline"
                    value="homePhoneGrantMessage"
                    isDisabled
                    // onChange={handleOnChange}
                  >
                    Leave message on home phone
                    <HStack>
                      <Controller
                        name="radiohomePhoneNon"
                        control={control}
                        render={props => (
                          <RadioGroup
                            onChange={props.onChange}
                            value={props.value}
                            // isDisabled
                            w="100%"
                            pt={{ base: '0px', lg: '10px' }}
                          >
                            <HStack alignItems="flex-start">
                              <Checkbox isDisabled value="homeVoice" ml="30px">
                                Voice
                              </Checkbox>
                              <Checkbox isDisabled value="homeText">
                                Text
                              </Checkbox>
                            </HStack>
                          </RadioGroup>
                        )}
                      />
                    </HStack>
                  </Checkbox>

                  <Checkbox
                    alignItems="baseline"
                    value="cellphoneGrantMessage"
                    // onChange={handleOnChangePhone}
                    pt="10px"
                    isDisabled
                  >
                    Leave message on cell phone*
                    <HStack>
                      <Controller
                        name="radioCellphone"
                        control={control}
                        render={props => (
                          <RadioGroup
                            onChange={props.onChange}
                            value={props.value}
                            // isDisabled={selectedRadioPhone}
                            w="100%"
                            pt={{ base: '0px', lg: '10px' }}
                          >
                            <HStack alignItems="flex-start">
                              <Checkbox isDisabled value="cellVoice" ml="30px">
                                Voice
                              </Checkbox>
                              <Checkbox isDisabled value="cellText">
                                Text
                              </Checkbox>
                            </HStack>
                          </RadioGroup>
                        )}
                      />
                    </HStack>
                    <VStack></VStack>
                  </Checkbox>
                </Grid>
                <VStack
                  w="100%"
                  direction={{ base: 'column', lg: 'row' }}
                  pt={{ base: '10px', lg: '15px' }}
                >
                  <Checkbox
                    isDisabled
                    value="Email"
                    w={{ base: '100%', lg: '99%' }}
                  >
                    Email message to my email address:
                  </Checkbox>
                  <Controller
                    name="email"
                    control={control}
                    defaultValue=""
                    render={props => (
                      <FormControl>
                        <Input
                          _readOnly={{
                            border: '1px solid #ccc',
                          }}
                          variant="no-effects"
                          readOnly
                          bg="#F9F9F9"
                          border="1px solid black"
                          w={{
                            base: '100%',
                            sm: '100%',
                            md: 'max-content',
                          }}
                          placeholder="Email"
                          value={props.value}
                          onChange={props.onChange}
                          onBlur={props.onBlur}
                        />
                      </FormControl>
                    )}
                  />
                </VStack>
              </CheckboxGroup>
            </FormControl>
          )}
        />
        <Text pt="20px" fontSize="14px">
          * Charges may be added by your carrier per your plan policy.
        </Text>
      </Box>
      <Center pt="2rem">{`2/${totalNonWebEnabledPage}`}</Center>
    </CardContent>
  )
}

export { PatientDemographics }
